import { useAuth } from '../../contexts/AuthContext';
import { ROLE_LABELS, ROLE_LEVEL } from '../../utils/constants';
import { Shield, X } from 'lucide-react';

export default function ImpersonationBanner() {
  const { impersonatingRole, stopImpersonation } = useAuth();

  if (!impersonatingRole) return null;

  return (
    <div
      data-testid="impersonation-banner"
      className="bg-amber-400 text-amber-950 px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium shrink-0 z-50"
    >
      <Shield className="w-4 h-4" />
      <span>
        Viewing as <strong>{ROLE_LABELS[impersonatingRole] || impersonatingRole}</strong> — write actions are disabled
      </span>
      <button
        onClick={stopImpersonation}
        data-testid="exit-impersonation-btn"
        className="ml-2 inline-flex items-center gap-1 px-2.5 py-0.5 rounded bg-amber-600 text-white text-xs font-semibold hover:bg-amber-700 transition-colors"
      >
        <X className="w-3 h-3" /> Exit
      </button>
    </div>
  );
}
